export const UNTRUSTED_HTML_ALLOWED_TAGS: ReadonlySet<string> = new Set([
  'p',
  'br',
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'sub',
  'sup',
  'span',
  'div',
  'blockquote',
  'pre',
  'code',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
  'hr',
  'a',
  'img',
]);

export const UNTRUSTED_HTML_VOID_TAGS: ReadonlySet<string> = new Set([
  'br',
  'hr',
  'img',
]);

// A tag absent from this record keeps no attributes.
export const UNTRUSTED_HTML_ALLOWED_ATTRIBUTES: Readonly<
  Record<string, ReadonlySet<string>>
> = {
  a: new Set(['href', 'title']),
  img: new Set(['src', 'alt', 'width', 'height']),
  td: new Set(['colspan', 'rowspan']),
  th: new Set(['colspan', 'rowspan']),
};

export const UNTRUSTED_HTML_ALLOWED_LINK_SCHEMES: ReadonlySet<string> = new Set(
  ['http', 'https', 'mailto'],
);

// `cid:` and raster `data:` only; `data:image/svg+xml` can carry script and remote loads.
export const UNTRUSTED_HTML_INLINE_IMAGE_SOURCE_PATTERN =
  /^(cid:|data:image\/(png|jpeg|gif|webp)[;,])/i;

// Dropped with everything inside them; any other unknown tag is unwrapped and keeps its children.
export const UNTRUSTED_HTML_DROPPED_WITH_CONTENT_TAGS: ReadonlySet<string> =
  new Set([
    'script',
    'style',
    'svg',
    'math',
    'template',
    'noscript',
    'textarea',
    'title',
    'iframe',
    'object',
    'embed',
    'frame',
    'frameset',
    'applet',
    'xmp',
    'noembed',
    'noframes',
    'plaintext',
    'select',
    'option',
    'head',
  ]);

// Plain-text attributes a value may fill on any tag.
export const UNTRUSTED_HTML_TEXT_ONLY_ATTRIBUTES: ReadonlySet<string> = new Set(
  ['alt', 'title'],
);

export const HTML_LINK_TAG = 'a';
export const HTML_IMAGE_TAG = 'img';
export const HTML_HREF_ATTRIBUTE = 'href';
export const HTML_SRC_ATTRIBUTE = 'src';
export const HTML_ALT_ATTRIBUTE = 'alt';

// Backslash covers CSS escapes (`u\72l(`) that hide the function name.
export const CSS_REMOTE_REFERENCE_PATTERN =
  /url\s*\(|image-set\s*\(|@import|\\|expression\s*\(/i;
